import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react';
import BodyPart from './BodyPart';
import { ScrollMenu, VisibilityContext } from 'react-horizontal-scrolling-menu';
import RightArrowIcon from '../assets/icons/right-arrow.png';
import LeftArrowIcon from '../assets/icons/left-arrow.png';
import ExerciseCard from './ExerciseCard';

// Left Arrow Button
const LeftArrow = () => {
  const { scrollPrev } = useContext(VisibilityContext);

  return (
    <Typography
      onClick={() => scrollPrev()} // Scroll to the previous item
      sx={{
        position: 'absolute',
        left: '10px', // Adjust position of the left arrow
        top: '20px', // Place it above the scrollable area
        transform: 'translateY(0)', // Align the arrow above the scrollable area
        cursor: 'pointer',
        zIndex: 10,
      }}
    >
      <img src={LeftArrowIcon} alt="left-arrow" />
    </Typography>
  );
};

// Right Arrow Button
const RightArrow = () => {
  const { scrollNext } = useContext(VisibilityContext);

  return (
    <Typography
      onClick={() => scrollNext()} // Scroll to the next item
      sx={{
        position: 'absolute',
        right: '10px', // Adjust position of the right arrow
        top: ' 20px', // Place it above the scrollable area
        transform: 'translateY(0)', // Align the arrow above the scrollable area
        cursor: 'pointer',
        zIndex: 10,
      }}
    >
      <img src={RightArrowIcon} alt="right-arrow" />
    </Typography>
  );
};

// Horizontal Scrollbar Component
const HorizontalScrollbar = ({ data, bodyParts, setBodyPart, bodyPart }) => {
  return (
    <Box sx={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
      <ScrollMenu
        // LeftArrow={LeftArrow} // Left Arrow Handler
        // RightArrow={RightArrow} // Right Arrow Handler
        sx={{ overflow: 'auto', display: 'flex' }} // Flex display to make the scroll horizontally
      >
        {data.map((item) => (
          <Box
            key={item.id || item}
            itemID={item.id || item} // Unique identifier for ScrollMenu
            title={item.id || item}
            m="0 20px" // Margin between items for better spacing
            sx={{
              flexShrink: 0, // Prevent items from shrinking to ensure proper display
              padding: '10px',
            }}
          >
            {bodyParts ? '' : <ExerciseCard exercise={item} />}
          </Box>
        ))}
      </ScrollMenu>
    </Box>
  );
};

export default HorizontalScrollbar;
